export default __webpack_public_path__ + "b8f6d3e8e558b5dae4f9d4595551d90f.png";